import React, { useState } from 'react';

interface ToggleAccordionProps {
  title: string;
  children: React.ReactNode;
  defaultOpen?: boolean;
}

const ToggleAccordion: React.FC<ToggleAccordionProps> = ({
  title,
  children,
  defaultOpen = false,
}) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  return (
    <div
      style={{
        width: '100%',
        gap: '8px',
        opacity: 1,
      }}
    >
      {/* Toggle Header */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        style={{
          width: '100%',
          height: '36px',
          borderRadius: '8px',
          border: '1px solid #0000001A',
          justifyContent: 'space-between',
          opacity: 1,
          padding: '8px 16px',
          background: '#F5F5F5',
          display: 'flex',
          alignItems: 'center',
          cursor: 'pointer',
          fontFamily: 'Noto Sans JP',
          fontSize: '14px',
          fontWeight: 500,
          color: '#0D357F',
        }}
      >
        <span>{title}</span>
        {/* Arrow Vector */}
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          style={{
            transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
            transition: 'transform 0.3s ease',
          }}
        >
          <path
            d="M4 6L8 10L12 6"
            stroke="#0A0A0A"
            strokeWidth="1.33"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>

      {/* Content */}
      {isOpen && (
        <div style={{ marginTop: '8px' }}>
          {children}
        </div>
      )}
    </div>
  );
};

export default ToggleAccordion;
